import React, {Dispatch, SetStateAction} from 'react';
import { BRAND, isMarketGB } from '../../constants/main';
import { BasketPriceDetailsAC } from './AC/BasketPriceDetails.AC';
import { BasketPriceDetailsOV } from './OV/BasketPriceDetails.OV';
import { BasketPriceDetailsAP } from './AP/BasketPriceDetails.AP';
import { BasketPriceDetailsDS } from './DS/BasketPriceDetails.DS';
import { BasketPriceDetailsOV as BasketPriceDetailsOV_GB } from './OV/GB/BasketPriceDetails.OV';
import { BasketPriceDetailsStyled } from './BasketPriceDetailsStyled';
import { SC } from '../../styles/theme';

export type BasketPriceDetailsProps = SC & {
    isOpenPriceDetails?: boolean;
    setIsOpenPriceDetails?: Dispatch<SetStateAction<boolean>>;
};

const BasketDealerDetails = (props: BasketPriceDetailsProps) => {
    if (BRAND === 'AC') return <BasketPriceDetailsAC {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? <BasketPriceDetailsOV_GB {...props} /> : <BasketPriceDetailsOV {...props} />;
    if (BRAND === 'AP') return <BasketPriceDetailsAP {...props} />;
    if (BRAND === 'DS') return <BasketPriceDetailsDS {...props} />;
    return <BasketPriceDetailsStyled {...props} />;
};

export default BasketDealerDetails;
